import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import { BoundaryComponent } from './boundary.component';
import {CustomElementService } from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {GeoAutoCompleteModule } from '../../../../formbird-mapping/src/lib/geo-auto-complete/geo-auto-complete.module';
import {SanitizingModule } from '../../../../formbird-mapping/src/lib/sanitizing/sanitizing.module';
import { default as pjson } from '../../../../../package.json';
import {StreetDataModule} from '../../../../formbird-mapping/src/lib/street-data/street-data.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTooltipModule,
    HttpClientModule,
    GeoAutoCompleteModule,
    SanitizingModule,
    StreetDataModule
  ],
  exports: [
    BoundaryComponent
  ],
  declarations: [
    BoundaryComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: []
})

export class BoundaryModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(BoundaryComponent, 'sc-boundary', this.injector, pjson.version);

  }
}
